import {mapActions, mapGetters, mapMutations} from 'vuex';
import Header from '@/components/header/index.vue'
import leftBar from '@/components/left-bar/index.vue'
import Table from '@/components/table/list/index.vue'
import TableOptions from '@/components/table/options/index.vue'
import popup from "@/components/popups/contacts/customers/index.vue";
import pagination from '@/components/pagination/index.vue'
import paginationMixin from '@/mixins/pagination/index.js'
import * as moment from "moment/moment";

export default {
    components:{
        Header,
        leftBar,
        Table,
        pagination,
        TableOptions,
        popup,
    },
    mixins: [paginationMixin],
    data(){
        return{
            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs:[
                {
                    key: 'userName',
                    labelKey: 'desktop.name'
                },
                {
                    key: 'userIp',
                    label: 'ip'
                },
                {
                    key: 'last_activity_at',
                    labelKey: 'desktop.last_activity'
                },
            ],
            items:[],
            selectedItem: null,
            showPopup: false,
            colOnline: 0,
            colOffline: 0,
        }
    },
    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide:'config/menuHide',
            dashboard:'contacts/dashboard',
        })
    },
    watch:{
        dashboard(e){
            this.items = []
            this.colOnline = 0;
            this.colOffline = 0;
            e.online_users.map(item=>{
                this.items.push({
                    'userName': item.name,
                    'userIp': item.away ? this.$t('desktop.offline') : item.ip ,
                    'last_activity_at': moment(item.last_activity_at).format('YYYY-MM-DD HH:mm'),
                    'away': item.away,
                });
                if(item.away){
                    this.colOffline++;
                }else{
                    this.colOnline++;

                }
            })
            this.res = e;
        },
        page(e) {
            this.getDashboard({page: e, perpage: this.perPage});
        },
        perPage(e) {
            this.getDashboard({page: this.page, perpage: e});
        }
    },
    created() {
        this.toggleLoadingStatus(true);
        this.getDashboard().then(()=>{
            this.toggleLoadingStatus(false);
        });
    },
    methods:{
        sendCustomer(form){
            this.addCustomer(form).then(res=>{
                if(res.status){
                    this.getDashboard({page: 1, perpage: this.perPage})
                    this.$toasted.success(this.$t('toasts.warehouse_added'),{
                        duration : 3000
                    });
                }
                this.showPopup = false;
            })
        },
        changeCustomer(form){
            this.editCustomer(form).then(res=>{
                if(res.status){
                    this.getDashboard({page: 1, perpage: this.perPage})
                    this.$toasted.success(this.$t('toasts.warehouse_updated'),{
                        duration : 3000
                    });
                    this.showPopup = false;
                }
            })
        },
        ...mapActions({
            getDashboard:'contacts/getDashboard',
            showCustomer:'contacts/showCustomer',
            editCustomer:'contacts/editCustomer',
            addCustomer:'contacts/addCustomer',
            removeCustomer:'contacts/removeCustomer',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        })
    }
}
